<template>
  <EdroneDrawer :open="open" width="35rem" @close="$emit('close')">
    <EdroneNavigationTop type="drawer">
      <template #header>
        <EdroneHeader type="h2">
          <template #title>
            <div class="tw:flex tw:gap-2 tw:items-center">
              <div class="tw:text-violet-500 tw:text-3xl">
                <i class="fa-kit fa-solid-chart-line-sparkle"></i>
              </div>
              <p class="tw:heading-2">{{ trans._readyFlows.smartInsight.drawer.header.title }}</p>
            </div>
          </template>
        </EdroneHeader>
      </template>
    </EdroneNavigationTop>

    <div class="tw:h-[calc(100%-8.625rem)] tw:overflow-y-auto tw:p-6">
      <slot />
    </div>

    <EdroneNavigationBottom>
      <template #start>
        <EdroneButton type="text" @click="$emit('close')">
          {{ trans._readyFlows.smartInsight.drawer.footer.btn.close }}
        </EdroneButton>
      </template>
    </EdroneNavigationBottom>
  </EdroneDrawer>
</template>

<script setup lang="ts">
import EdroneDrawer from "edrone-components/EdroneDrawer.vue";
import EdroneHeader from "edrone-components/EdroneHeader.vue";
import EdroneNavigationTop from "edrone-components/EdroneNavigationTop.vue";
import EdroneNavigationBottom from "edrone-components/EdroneNavigationBottom.vue";
import EdroneButton from "edrone-components/EdroneButton.vue";

interface Props {
  open: boolean;
}

defineProps<Props>();
defineEmits(["close"]);
</script>
